export default "__VITE_ASSET__BgzvuTOM__"